export default __webpack_public_path__ + "static/media/educafro.ccf7a7bb.jpg";